module.exports = __webpack_public_path__ + "static/media/nature-primary.b6f238fa.jpg";